// Template Generated by DataExtraction.py at 1714177343

import EnrolmentFormsEn2 from "../../Forms/Enrolment Forms/EnrolmentForms_En2.png";
import EnrolmentFormsEn2Labels from "../../Labels/Enrolment Forms/EnrolmentForms_En2.json";
import EnrolmentFormsFr2 from "../../Forms/Enrolment Forms/EnrolmentForms_Fr2.png";
import EnrolmentFormsFr2Labels from "../../Labels/Enrolment Forms/EnrolmentForms_Fr2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    formatDayFromDate,
    formatMonthFromDate,
    formatYearFromDate,
    isMale,
    isFemale,
    getCustodianAddress,
    getSubscriber1Address,
    calculateDepositAmountPlan1,
    calculateDepositWithApplicationPlan1,
    calculateInterestDeficiencyPlan1,
    calculateDepositWithApplicationPlan2,
    calculateDepositAmountPlan2,
    calculateInterestDeficiencyPlan2, isAnotherGender
} from "../../PDFGenerationUtils";
import moment from "moment/moment";
import app from "../../../App";
import { calculateLifetimeDepositAmount, PLAN_TYPE_IDS, stateWithPlan2AsPrimary } from "../../../Utils/PlanUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? EnrolmentFormsFr2Labels : EnrolmentFormsEn2Labels;
    const formImage = isFrench ? EnrolmentFormsFr2 : EnrolmentFormsEn2;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, true);
    }

    const nowDate = moment(new Date()).format("YYYY-MM-DD");


    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const beneficiary = data.beneficiary;
    const application = data.application;
    const common = data.common;
    const plan = data.plan;
    const plan2 = data.plan2;

    // Drawing the form
    // TODO IPad enrollment2viewcontroller has reference to airMiles.text but doesn't appear in labels need to verify removed
    // TODO implement fields
    drawText(application.agreementNumber, "agreementNumber");
    // drawText(subscriber.airMiles, "airmilesCollectorNumber"); // TODO appears to be not set in ipad
    drawText(formatDayFromDate(beneficiary.birthdate), "beneficiaryBirthdateDay");
    drawText(formatMonthFromDate(beneficiary.birthdate), "beneficiaryBirthdateMonth");
    drawText(formatYearFromDate(beneficiary.birthdate), "beneficiaryBirthdateYear");
    drawText(application.beneficiaryCertificateInscription, "beneficiaryCertificateInscription");
    drawText(application.custodianCity, "beneficiaryCity");
    drawText(application.custodianCountry, "beneficiaryCountry");

    fillCheckbox(isFemale(beneficiary.gender), "beneficiaryFemale");
    fillCheckbox(isMale(beneficiary.gender), "beneficiaryMale");
    fillCheckbox(isAnotherGender(beneficiary.gender), "beneficiaryAnother")

    drawText(beneficiary.firstName + (beneficiary.middleName ? ` ${beneficiary.middleName}` : ""), "beneficiaryFirstName");
    drawText(beneficiary.lastName, "beneficiaryLastName");
    drawText(application.custodianPostalCode, "beneficiaryPostalCode");
    drawText(application.custodianProvince == "N/A" ? "" : application.custodianProvince, "beneficiaryProvince");
    drawText(beneficiary.relationshipToSubscriber, "beneficiaryRelationshipToSubscriber");
    drawText(beneficiary.sin, "beneficiarySIN");
    drawText(application.custodianSIN, "custodianSIN");
    drawText(nowDate, "dateOfEnrolment");


    drawText(calculateDepositWithApplicationPlan1(data), "depositWithApplication");
    drawText(formatDayFromDate(plan.effectiveDate), "effectiveDateDay");
    drawText(formatMonthFromDate(plan.effectiveDate), "effectiveDateMonth");
    drawText(formatYearFromDate(plan.effectiveDate), "effectiveDateYear");

    fillCheckbox(!isFrench, "english");
    fillCheckbox(isFrench, "french");
    drawText(formatDayFromDate(plan.initialDepositDate), "initialDepositDateDay");
    drawText(formatMonthFromDate(plan.initialDepositDate), "initialDepositDateMonth");
    drawText(formatYearFromDate(plan.initialDepositDate), "initialDepositDateYear");

    fillCheckbox(plan.initialDepositMethod == "Cheque", "initialDepositMethodCheque");
    fillCheckbox(plan.initialDepositMethod == "Credit Card", "initialDepositMethodCreditCard");
    fillCheckbox(plan.initialDepositMethod == "PAP", "initialDepositMethodPAP");
    drawText(calculateInterestDeficiencyPlan1(data) == 0 ? "" : calculateInterestDeficiencyPlan1(data), "interestDeficiency");
    drawText(formatYearFromDate(plan.maturityDate), "maturityYearRequested");

    if (plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        drawText(calculateLifetimeDepositAmount(data, false).toFixed(2), "planContributionTarget1");
    }

    drawText(calculateDepositAmountPlan1(data), "depositAmount");

    if (plan2.planTypeID >= 0 && plan2.planTypeID < 100) {

        if (plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
            drawText(calculateLifetimeDepositAmount(stateWithPlan2AsPrimary(data), false).toFixed(2), "planContributionTarget2");
        }
        fillCheckbox(plan2.initialDepositMethod == "PAP", "initialDepositMethodPAP2");
        fillCheckbox(plan2.initialDepositMethod == "Credit Card", "initialDepositMethodCreditCard2");
        fillCheckbox(plan2.initialDepositMethod == "Cheque", "initialDepositMethodCheque2");

        drawText(formatDayFromDate(plan2.initialDepositDate), "initialDepositDateDay2");
        drawText(formatMonthFromDate(plan2.initialDepositDate), "initialDepositDateMonth2");
        drawText(formatYearFromDate(plan2.initialDepositDate), "initialDepositDateYear2");

        drawText(formatDayFromDate(plan2.effectiveDate), "effectiveDateDay2");
        drawText(formatMonthFromDate(plan2.effectiveDate), "effectiveDateMonth2");
        drawText(formatYearFromDate(plan2.effectiveDate), "effectiveDateYear2");

        drawText(formatYearFromDate(plan2.maturityDate), "maturityYearRequested2");
        drawText(calculateInterestDeficiencyPlan2(data) ? "" : calculateInterestDeficiencyPlan2(data), "interestDeficiency2");

        drawText(calculateDepositAmountPlan2(data), "depositAmount2");

        // group plan or self initiated
        if (plan2.planTypeID == PLAN_TYPE_IDS.GROUP || plan2.planTypeID == PLAN_TYPE_IDS.SI) {
            fillCheckbox(plan2.depositMode == "M", "depositFrequencyMonthly2");
            fillCheckbox(plan2.depositMode == "A", "depositFrequencyAnnual2");
            fillCheckbox(plan2.depositMode == "T", "depositFrequencyOneTime2");
            fillCheckbox(plan2.depositMode == "P", "depositFrequency5yrMonthly2");
            fillCheckbox(plan2.depositMode == "F", "depositFrequency5yrAnnual2");
            fillCheckbox(plan2.depositMode == "X", "depositFrequency10yrMonthly2");
            fillCheckbox(plan2.depositMode == "Y", "depositFrequency10yrAnnual2");

            drawText(plan2.numberOfUnits.toFixed(3), "units2"); // TODO may need to be localized ',' in french?
        }

        if (plan2.depositMode != "T") {
            fillCheckbox(plan2.ongoingDepositMethod == "PAP", "ongoingDepositMethodPAP2");
            fillCheckbox(plan2.ongoingDepositMethod == "Credit Card", "ongoingDepositMethodCreditCard2");
            fillCheckbox(plan2.ongoingDepositMethod == "Cupon", "ongoingDepositMethodCoupon2");

            fillCheckbox(plan2.requestedDepositDate == "1st of the month", "requestedDepositDate1st2");
            fillCheckbox(plan2.requestedDepositDate == "8th of the month", "requestedDepositDate8th2");
            fillCheckbox(plan2.requestedDepositDate == "15th of the month", "requestedDepositDate15th2");
            fillCheckbox(plan2.requestedDepositDate == "22nd of the month", "requestedDepositDate22nd2");
            fillCheckbox(plan2.requestedDepositDate == "28th of the month", "requestedDepositDate28th2");
        }

        if (plan2.planTypeID == 2) {
            fillCheckbox(plan2.depositMode == "M", "depositFrequencyAchieversMonthly2");
            fillCheckbox(plan2.depositMode == "A", "depositFrequencyAchieversAnnual2");
            fillCheckbox(plan2.depositMode == "S", "depositFrequencyAchieversSemiAnnual2");
            fillCheckbox(plan2.depositMode == "Q", "depositFrequencyAchieversQuarterly2");
            fillCheckbox(plan2.depositMode == "T", "depositFrequencyAchieversOneTime2");
        }

        drawText(calculateDepositWithApplicationPlan2(data), "depositWithApplication2");

        fillCheckbox(plan2.planTypeID == 0, "planSelectionGroupOption4");
        fillCheckbox(plan2.planTypeID == 1, "planSelectionSelfInitiated4");
        fillCheckbox(plan2.planTypeID == 2, "planSelectionAchievers4");
    }


    if (plan.depositMode != "T") {
        fillCheckbox(plan.ongoingDepositMethod == "PAP", "ongoingDepositMethodPAP");
        fillCheckbox(plan.ongoingDepositMethod == "Credit Card", "ongoingDepositMethodCreditCard");
        fillCheckbox(plan.ongoingDepositMethod == "Cupon", "ongoingDepositMethodCoupon");

        fillCheckbox(plan.requestedDepositDate == "1st of the month", "requestedDepositDate1st");
        fillCheckbox(plan.requestedDepositDate == "8th of the month", "requestedDepositDate8th");
        fillCheckbox(plan.requestedDepositDate == "15th of the month", "requestedDepositDate15th");
        fillCheckbox(plan.requestedDepositDate == "22nd of the month", "requestedDepositDate22nd");
        fillCheckbox(plan.requestedDepositDate == "28th of the month", "requestedDepositDate28th");
    }

    fillCheckbox(plan.planTypeID == 0, "planSelectionGroupOption3");
    fillCheckbox(plan.planTypeID == 1, "planSelectionSelfInitiated3");
    fillCheckbox(plan.planTypeID == 2, "planSelectionAchievers3");


    // drawText(publicPrimaryCaregiverBN, "publicPrimaryCaregiverBN"); // always blank on ipad
    if (application.custodianLastName) {
        drawText(`${application.custodianFirstName} ${application.custodianLastName}, ${getCustodianAddress(application)}`, "publicPrimaryCaregiversNameAndAddress");
    }

    if (common.specialReferralAgreement) {
        drawText("x", "referralAgreementYes");
    } else {
        fillCheckbox(!common.referralAgreement, "referralAgreementNo");
        fillCheckbox(common.referralAgreement, "referralAgreementYes");
    }
    if (!common.subscriberEngOrFr) {
        fillCheckbox(!common.representativeDetails, "representativeDetailsNo");
        fillCheckbox(!!common.representativeDetails, "representativeDetailsYes");
    }

    // group plan or self initiated
    if (plan.planTypeID == PLAN_TYPE_IDS.GROUP || plan.planTypeID == PLAN_TYPE_IDS.SI) {
        fillCheckbox(plan.depositMode == "M", "depositFrequencyMonthly");
        fillCheckbox(plan.depositMode == "A", "depositFrequencyAnnual");
        fillCheckbox(plan.depositMode == "T", "depositFrequencyOneTime");
        fillCheckbox(plan.depositMode == "P", "depositFrequency5yrMonthly");
        fillCheckbox(plan.depositMode == "F", "depositFrequency5yrAnnual");
        fillCheckbox(plan.depositMode == "X", "depositFrequency10yrMonthly");
        fillCheckbox(plan.depositMode == "Y", "depositFrequency10yrAnnual");

        drawText(plan.numberOfUnits.toFixed(3), "units"); // TODO may need to be localized ',' in french?
    }

    if (plan.planTypeID == 2) {
        fillCheckbox(plan.depositMode == "M", "depositFrequencyAchieversMonthly");
        fillCheckbox(plan.depositMode == "A", "depositFrequencyAchieversAnnual");
        fillCheckbox(plan.depositMode == "S", "depositFrequencyAchieversSemiAnnual");
        fillCheckbox(plan.depositMode == "Q", "depositFrequencyAchieversQuarterly");
        fillCheckbox(plan.depositMode == "T", "depositFrequencyAchieversOneTime");
    }


    drawText(subscriber.email, "subscribeEmail");
    drawText(formatDayFromDate(subscriber.birthdate), "subscriber1BirthdateDay");
    drawText(formatMonthFromDate(subscriber.birthdate), "subscriber1BirthdateMonth");
    drawText(formatYearFromDate(subscriber.birthdate), "subscriber1BirthdateYear");
    drawText(subscriber.firstName + (subscriber.middleName ? ` ${subscriber.middleName}` : ""), "subscriber1FirstName");
    drawText(subscriber.id, "subscriber1ID");
    drawText(subscriber.lastName, "subscriber1LastName");
    if (subscriber.primaryCaregiver) {
        fillCheckbox(true, "subscriber1PrimaryCaregiverYes");
    } else {
        if (subscriber.pcgSpouse) {
            fillCheckbox(true, "subscriber1PrimaryCaregiverSpouse");
        } else {
            fillCheckbox(true, "subscriber1PrimaryCaregiverNo");
        }
    }
    drawText(subscriber.sin, "subscriber1SIN");
    drawText(subscriber.title, "subscriber1Title");
    if (common.subscriber2Include) {
        // birthdate
        drawText(formatDayFromDate(jointSubscriber.birthdate), "subscriber2BirthdateDay");
        drawText(formatMonthFromDate(jointSubscriber.birthdate), "subscriber2BirthdateMonth");
        drawText(formatYearFromDate(jointSubscriber.birthdate), "subscriber2BirthdateYear");

        drawText(jointSubscriber.firstName + (jointSubscriber.middleName ? ` ${jointSubscriber.middleName}` : ""), "subscriber2FirstName");
        drawText(jointSubscriber.id, "subscriber2ID");
        drawText(jointSubscriber.lastName, "subscriber2LastName");
        drawText(jointSubscriber.sin, "subscriber2SIN");
        drawText(jointSubscriber.title, "subscriber2Title");
    }

    if (jointSubscriber.primaryCaregiver) {
        fillCheckbox(true, "subscriber2PrimaryCaregiverYes");
    } else {
        if (jointSubscriber.pcgSpouse) {
            fillCheckbox(true, "subscriber2PrimaryCaregiverSpouse");
        } else {
            fillCheckbox(true, "subscriber2PrimaryCaregiverNo");
        }
    }

    drawText(getSubscriber1Address(subscriber), "subscriberAddress");
    drawText(subscriber.businessPhone, "subscriberBusinessPhone");
    drawText(subscriber.city, "subscriberCity");
    drawText(subscriber.country, "subscriberCountry");
    fillCheckbox(!common.subscriberEngOrFr, "subscriberEngOrFrNo");
    fillCheckbox(common.subscriberEngOrFr, "subscriberEngOrFrYes");
    drawText(subscriber.homePhone, "subscriberHomePhone");
    drawText(subscriber.postalCode, "subscriberPostalCode");
    drawText(subscriber.province == "N/A" ? "" : subscriber.province, "subscriberProvince");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    return null;
}

export default {
    generate,
    signatureDefinitions
}
